import { ActivityEventDto } from '../../../shared/modules/activity/dtos/activity-event.dto';
import { VehicleRoadWorthyCheckActivityEventHydration } from './vehicle-road-worthy-check-activity-event-hydration.dto';

/**
 * A vehicle road worthy check activity event with hydrated related records.
 */
export class VehicleRoadWorthyCheckActivityEventDto extends ActivityEventDto {
  hydrated?: VehicleRoadWorthyCheckActivityEventHydration;
}
